import { Box, Link } from "@mui/material";
import { useLocales } from "../../../locales";
import { CommonWrap } from "../../common";
import Table from "../../../DocLayout/Table";
import ContentWrap from "../../../DocLayout/Content/Index";
import CodeSnippet from "../../../components/CodeSnippet";
import { USER_COIN_LIST, GET_USER_LIST_URL, USER_COIN_ } from "@/config";
import { Trans } from "react-i18next";
import { codeMap } from "@/PageCodeComponents/MerchantUserWalletModeAPI";
import { useContext } from "react";
import { ChooseCodeLanguageContext } from "@/components/ChooseCodeLanguage/ChooseCodeLanguage";
import PostRequest from "@/components/PostRequest";
export default function Index() {
  const { translate } = useLocales();
  const { language } = useContext(ChooseCodeLanguageContext);
  return (
    <div>
      {/* 获取用户资产列表 */}
      <ContentWrap
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box id="create-a-wallet-system" className="title">
              {translate("merchant_user_wallet_mode_API.title")}
            </Box>
            <Box className="desc">
              <Trans
                i18nKey={"merchant_user_wallet_mode_API.text_95"}
                t={translate as any}
              >
                Just a placeholder
                <Link
                  href={GET_USER_LIST_URL}
                  target="_blank"
                  className="link"
                  underline="always"
                >
                  Just a placeholder
                </Link>
              </Trans>
            </Box>
            <Box id="user-asset-inquiry" className="title_0">
              {translate("merchant_user_wallet_mode_API.title_1")}
            </Box>
            <Box id="get-a-list-of-user-assets" className="title_1">
              {translate("merchant_user_wallet_mode_API.title_1_1")}
            </Box>
            <Box className="desc">
              {translate("merchant_user_wallet_mode_API.title_1_1_desc")}
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={USER_COIN_LIST} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "userId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.request")}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={codeMap["user_coin_asset_list"][language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取用户资产列表 返回 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.userId",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_id"
                  )}`,
                },
                {
                  name: "data.assets",
                  type: "Array",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_assets"
                  )}`,
                },
                {
                  name: "data.assets[index].coinId",
                  type: "Integer",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "data.assets[index].coinSymbol",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_symbol"
                  )}`,
                },
                {
                  name: "data.assets[index].available",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_number"
                  )}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["user_coin_asset_list"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取用户代币资产 */}
      <ContentWrap
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box id="acquisition-of-user-token-assets" className="title_0">
              {translate("merchant_user_wallet_mode_API.title_2")}
            </Box>
            <Box className="desc">
              {translate("merchant_user_wallet_mode_API.title_2_desc")}
            </Box>

            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={USER_COIN_} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "userId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.request")}`,
                },
                {
                  name: "coinId",
                  type: "Integer",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={codeMap["user_coin_asset"][language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取用户代币资产 返回 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.userId",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_id"
                  )}`,
                },
                {
                  name: "data.assets",
                  type: "Array",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_assets"
                  )}`,
                },
                {
                  name: "data.assets[index].coinId",
                  type: "Integer",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "data.assets[index].coinSymbol",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_symbol"
                  )}`,
                },
                {
                  name: "data.assets[index].available",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_number"
                  )}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["user_coin_asset"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
    </div>
  );
}
